module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/receiver-selector/receiver-selector.component.css
// module id = ./src/app/components/receiver-selector/receiver-selector.component.css
// module chunks = main